import { getPlayer } from '../../../api/endpoints/getPlayerDetails';
import { getRealBonusHistory } from '../../../api/endpoints/getRealBonusHistory';
import { ActionsType, PropertyType, SortParams, sortData } from '../../../common';

const playerInit = async (payload: PropertyType) => {
	const { token, id } = payload;
	const { player } = await getPlayer({
		token,
		id,
	});

	return {
		playerLoading: false,
		player: player,
	};
};

const realBonusHistoryInit = async (payload: PropertyType) => {
	const { token, playerId } = payload;
	const history = await getRealBonusHistory({
		token,
		playerId,
	});

	return {
		playerLoading: false,
		realBonusHistory: sortData(history, { type: 'date', field: 'create_time', isAsc: false }),
	};
};

const realBonusHistorySort = (state: PropertyType, payload: SortParams) => {
	const history = sortData(state.realBonusHistory, payload);
	return {
		realBonusHistory: history,
	};
};

const partnersInit = (user: PropertyType) => {
	const { partners } = user;
	return { partners };
};

export const actions: ActionsType = {
	LOADING: (state, payload) => ({ playerLoading: payload }),
	PARTNERS_INIT: (state, payload) => partnersInit(payload),
	PLAYER_INIT: (state, payload) => playerInit(payload),
	REAL_BONUS_HISTORY_INIT: (state, payload) => realBonusHistoryInit(payload),
	REAL_BONUS_HISTORY_SORT: (state, payload) => realBonusHistorySort(state, payload),
	UPDATE_REAL_BONUS_HISTORY_ROWS: (state, payload) => ({ realBonusHistoryRows: payload }),
	UPDATE_ROWS: (state, payload) => ({ historyRows: payload }),
	GLOBAL_ERROR: (state, payload) => ({ globalErrors: payload }),
	GLOBAL_SUCCESS: (state, payload) => ({ globalSuccess: payload }),
	MESSAGE_INVALIDATE: () => ({ globalErrors: [], globalSuccess: '', playerLoading: false }),
};
